<template>
  <div class="bankCardManagement">
    <div class="select">
      <el-form ref="form" :model="request" label-position="right">
        <el-form-item><el-input v-model="request.name" placeholder="名称" style="width:150px" clearable></el-input></el-form-item>
        <el-form-item><el-input v-model="request.phone" placeholder="电话" style="width:150px" clearable></el-input></el-form-item>
        <el-form-item>
          <el-button style="background-color:#A9F5F2;margin: 0" icon="el-icon-search" @click="getAllBankCard">搜索</el-button>
          <el-button style="background-color:#A9F5A9" icon="el-icon-refresh" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="data">
      <el-table :data="response.data" style="margin:auto;width:calc(100% - 30px)" height="800" border :row-style="{ height: '0.2%' }" :cell-style="{ padding: '0.2%' }"
                :header-cell-style="{background:'#01DFD7',color:'#fff'}">
        <el-table-column label="用户名称" align="center" prop="userName"></el-table-column>
        <el-table-column label="类型" align="center" prop="type" width="80"></el-table-column>
        <el-table-column label="联系方式" align="center" prop="userMobile"></el-table-column>
        <el-table-column label="真实姓名" align="center" prop="realName"></el-table-column>
        <el-table-column label="银行卡号" align="center" prop="creditCard"></el-table-column>
        <el-table-column label="身份证号" align="center" prop="cardNo"></el-table-column>
        <el-table-column label="银行预留手机号" align="center" prop="mobile"></el-table-column>
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <el-button type="warning" size="small" plain @click="modify(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="query.current" :total="response.total" @current-change="currenChangeHandle" layout="total, prev, pager, next, jumper" :page-size="query.size"/>
    </div>
    <modify-bank-card v-if="modifyDialog" ref="modifyBankCard" @modify-succeed="modifySucceed"></modify-bank-card>
  </div>
</template>
<script>
import {getAllBankCard} from '../../../api/withdraw/bankCardManagement.js'
import ModifyBankCard from './modifyBankCard.vue'
export default {
  name: 'BankManagement',
  components: {ModifyBankCard},
  data() {
    return {
      request: {
        phone: '',
        name: '',
        current: '',
        size: ''
      },
      query: {current: 1, size: 20},
      response: {data: [],total: 0},
      modifyDialog: false
    }
  },
  methods: {
    getAllBankCard(){
      this.request.current = this.query.current;
      this.request.size = this.query.size;
      getAllBankCard(this.request).then(result=>{
        this.response.data = result.data.records;
        this.response.total = result.data.total;
      })
    },

    /**
     * 页码改变
     */
    currenChangeHandle(value){
      this.query.current = value;
      this.getAllBankCard();
    },

    /**
     * 重置
     */
    reset(){
      this.query.current = 1;
      this.request.name = "";
      this.request.phone = "";
      this.getAllBankCard();
    },

    /**
     * 编辑
     */
    modify(item){
      this.modifyDialog = true;
      this.$nextTick(()=>{
        this.$refs.modifyBankCard.init(item);
      })
    },

    /**
     * 修改成功，重新请求
     */
    modifySucceed(){
      this.getAllBankCard();
    }
  },
  created() {
    this.getAllBankCard();
  }
}
</script>

<style scoped>
.bankCardManagement {
  width: 100%;
  height: 100%;
}
.el-form {
  float: left;
}
.el-form-item {
    display: inline-block !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/finance/withdrawmanagement/bankmanagement.vue